import {
  project_delete_path
} from '~/routes'

export const Applicant = {
	index: function() {
		//console.log("index");
    ActionJS.Support._initVideo();
	},

	manage_users: function() {
		if ($('#user-table').DataTable().data().length <= $('#user-table').DataTable().page.len()) {
			$('ul.pagination').hide();
		}
	},

	application_form: function() {
		// $(document).on('input', 'textarea', function () {
    //     	$(this).outerHeight(38).outerHeight(this.scrollHeight);
    // 	});

    // 	$('textarea').each(function (obj) {
    // 		$(this).outerHeight(38).outerHeight(this.scrollHeight);
    // 	});
	},

	applications: function() {
    ActionJS.Applicant._collapseHighlight();
		$('.project-remove').on('click', function () {
			if (confirm(I18n.t('confirm_delete_project'))) {
				$.ajax({
					url: project_delete_path({project_id: jQuery(this).data('project-id')}),
					method: 'POST',
					data: {explanation: 'Applicant deleted draft'}
				}).error(function(){
					alert('Error occurred when deleting the project.')
				}).done(function() {
				});
				$(this).closest('tr').remove();
			}
    });
    
    jQuery('[data-tooltip="true"]').tooltip();
	},

	application_save: function() {
		ActionJS.Applicant.application_form();
  },
  
  _collapseHighlight: function(){
    if ( localStorageWithExpiry.getItem('collapseSidebar') === null ){
      setTimeout(function(){
        jQuery('.navbar-collapse-toggle').trigger('click');
        setTimeout(function(){
          jQuery('.navbar-collapse-toggle').addClass('flash').tooltip({title: I18n.t('uncollapse_hint'), trigger: 'manual', container: 'body'}).tooltip('show')
          setTimeout(function(){
            jQuery('.navbar-collapse-toggle').tooltip('hide');
          }, 5000);
        }, 300);
      }, 600)
    }
  },

  _countDownInterval: null,
  _ready: function() {

		if(jQuery('#applicant-navbar').length < 1){
			return;
		}

		var initCountdown = function() {
	      var $counter = jQuery('.countdown-to-deadline, .countdown-to-deadline-compact');
	      if ($counter.length === 0) return;

				var counters = []

				$counter.each(function(index) {
					var serverTime = dayjs($($counter[index]).data('server-time-utc')).utc();
					counters.push({
						$days: $($counter[index]).find('.days .countdown-value'),
						$hours: $($counter[index]).find('.hours .countdown-value'),
						$minutes: $($counter[index]).find('.minutes .countdown-value'),
						$seconds: $($counter[index]).find('.seconds .countdown-value'),
						until: dayjs($($counter[index]).data('countdown-to-time-utc')).utc(),
						offset: serverTime.unix() - dayjs().utc().unix()
					})
				});

        ActionJS.Applicant._countDownInterval = setInterval(function() {
					counters.forEach(function(c) {
						var seconds = c.until.diff(dayjs().utc(), 'seconds') - c.offset,
							days = 0,
								hours = 0,
								minutes = 0;
	
						if (seconds > 0) {
							days = Math.floor(seconds / (60 * 60 * 24));
							seconds -= days * (60 * 60 * 24);
							hours = Math.floor(seconds / (60 * 60));
							seconds -= hours * (60 * 60);
							minutes = Math.floor(seconds / 60);
							seconds -= minutes * 60;
							seconds = Math.floor(seconds);
						} else {
							seconds = 0;
						}
	
						c.$days.html(days);
						c.$hours.html(hours);
						c.$minutes.html(minutes);
						c.$seconds.html(seconds);
					});
	      }, 1000);
	    };

	    initCountdown();
	},

  _cleanup: function(){
    clearInterval(ActionJS.Applicant._countDownInterval);
  }


};